module.exports = __webpack_public_path__ + "img/Schnute.c6baa700.jpg";